export default "__VITE_ASSET__Bd49LEgt__"